import { useEffect, useState } from "react";
import Lenis from "lenis";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import WhatWeDo from "@/components/site/WhatWeDo";
import AIStudio from "@/components/site/AIStudio";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Concierge from "@/components/site/Concierge";

export default function App() {
  const [conciergeOpen, setConciergeOpen] = useState(false);
  const openConcierge = () => setConciergeOpen(true);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div data-testid="gm-app" className="min-h-screen bg-black text-[#F4F4F5] antialiased">
      <Nav onOpenConcierge={openConcierge} />
      <main>
        <Hero onOpenConcierge={openConcierge} />
        <Marquee />
        <WhatWeDo />
        <AIStudio />
        <Contact onOpenConcierge={openConcierge} />
      </main>
      <Footer />
      <Concierge open={conciergeOpen} onClose={() => setConciergeOpen(false)} />
    </div>
  );
}
